import { Controller } from "@hotwired/stimulus"

// Mostra os campos que fazem sentido para o tipo escolhido: um login de site
// pede URL; um banco ou broker pede host, porta e dados extras de conexão.
//
// Os campos escondidos são DESABILITADOS, não só ocultados. Um input
// display:none continua participando da validação nativa do HTML — uma URL
// inválida escondida trava o envio do formulário sem mensagem nenhuma,
// porque o navegador não consegue focar o campo para reclamar. Desabilitar
// também impede que valores do outro tipo sejam enviados junto.
export default class extends Controller {
  static targets = ["kind", "siteFields", "connectionFields"]

  connect() {
    this.toggle()
  }

  toggle() {
    const isLogin = this.kindTarget.value === "login"
    this.apply(this.siteFieldsTarget, isLogin)
    this.apply(this.connectionFieldsTarget, !isLogin)
  }

  apply(group, visible) {
    group.classList.toggle("hidden", !visible)
    group.querySelectorAll("input, select, textarea").forEach((field) => {
      field.disabled = !visible
    })
  }
}
